import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { DataService } from 'src/app/data.service';

interface RiportTipus { tipus: string; cim: string; datumMezo: string; }
interface RiportOszlop { key: string; label: string; tipus?: string; }
interface RiportAdat {
  tipus: string; cim: string; datumMezo: string;
  oszlopok: RiportOszlop[];
  sorok: any[];
  osszesites: { label: string; value: any; tipus?: string }[];
}

// CAESAR Riportok: az ügyvédnek kötelezően vezetendő nyilvántartások (JÜB, PMT, letét,
// munkadíj, költség, postakönyv) szűrhető összesítője, XLSX/PDF exporttal.
@Component({
  selector: 'app-caesar-riportok',
  templateUrl: './riportok.component.html',
  styleUrls: ['./riportok.component.scss'],
})
export class RiportokComponent implements OnInit {
  intezmeny = '';
  tipusok: RiportTipus[] = [];
  aktivTipus = 'jub';
  tol = '';
  ig = '';
  adat: RiportAdat | null = null;
  betoltes = false;
  exportFolyamatban = '';

  constructor(private http: HttpClient, private data: DataService) {}

  async ngOnInit() {
    const si = await this.data.getFromStorage('sajatIntezmeny');
    this.intezmeny = si?.intezmenyId || '';
    // Alapból az aktuális év.
    const ev = new Date().getFullYear();
    this.tol = `${ev}-01-01`;
    this.ig = `${ev}-12-31`;
    try {
      this.tipusok = await firstValueFrom(this.http.get<RiportTipus[]>('/api/caesar/riportok'));
    } catch { this.tipusok = []; }
    await this.betolt();
  }

  valasztTipus(tipus: string) {
    if (this.aktivTipus === tipus) return;
    this.aktivTipus = tipus;
    this.betolt();
  }

  private queryString(): string {
    const p = new URLSearchParams();
    p.set('tipus', this.aktivTipus);
    if (this.tol) p.set('tol', this.tol);
    if (this.ig) p.set('ig', this.ig);
    return p.toString();
  }

  async betolt() {
    if (!this.intezmeny || !this.aktivTipus) return;
    this.betoltes = true;
    this.adat = null;
    try {
      this.adat = await firstValueFrom(
        this.http.get<RiportAdat>(`/api/caesar/riport/${this.intezmeny}?${this.queryString()}`)
      );
    } catch {
      this.data.sendToast('Nem sikerült betölteni a riportot.', 'error');
    } finally {
      this.betoltes = false;
    }
  }

  async export(formatum: 'xlsx' | 'pdf') {
    if (!this.intezmeny || !this.aktivTipus) return;
    this.exportFolyamatban = formatum;
    try {
      const blob = await firstValueFrom(
        this.http.get(`/api/caesar/riport-export/${this.intezmeny}?${this.queryString()}&format=${formatum}`,
          { responseType: 'blob' })
      );
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${this.aktivTipus}_riport.${formatum}`;
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      this.data.sendToast('Nem sikerült exportálni a riportot.', 'error');
    } finally {
      this.exportFolyamatban = '';
    }
  }

  cella(sor: any, o: RiportOszlop): string {
    const v = sor[o.key];
    if (v == null || v === '') return '–';
    if (o.tipus === 'bool') return Number(v) === 1 ? 'Igen' : 'Nem';
    if (o.tipus === 'penz') return `${this.szam(v)} Ft`;
    return String(v);
  }

  ossz(o: { value: any; tipus?: string }): string {
    if (o.tipus === 'penz') return `${this.szam(o.value)} Ft`;
    return String(o.value ?? 0);
  }

  private szam(v: any): string {
    const n = Number(v) || 0;
    return n.toLocaleString('hu-HU');
  }
}
